import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { BorderedGrid } from '@shared/components/borderedGrid';
import { SettingsBlockKey, SettingsBlockContentProps } from './types';

export interface ExpandableSettingsBlockProps extends SettingsBlockContentProps {
  id: SettingsBlockKey;
  expanded: boolean;
  onChange: (expanded: boolean) => void;
}

export const ExpandableSettingsBlock: React.FC<ExpandableSettingsBlockProps> = ({
  id,
  expanded,
  onChange,
  header,
  children,
}) => (
  <BorderedGrid sx={{ padding: 0, overflow: 'hidden' }}>
    <Accordion
      disableGutters
      elevation={0}
      expanded={expanded}
      onChange={(event, nextExpanded) => {
        const target = event.target as HTMLElement;

        if (target.closest('input, [role="switch"]')) {
          return;
        }

        onChange(nextExpanded);
      }}
      sx={{ '&:before': { display: 'none' } }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${id}-settings-content`}
        id={`${id}-settings-header`}
        sx={{
          minHeight: 72,
          px: 2.5,
          '& .MuiAccordionSummary-content': { mr: 1.5 },
        }}>
        {header}
      </AccordionSummary>
      <AccordionDetails id={`${id}-settings-content`} sx={{ px: 2.5, pb: 2.5, pt: 0 }}>
        {children}
      </AccordionDetails>
    </Accordion>
  </BorderedGrid>
);

export const StaticSettingsBlock: React.FC<SettingsBlockContentProps> = ({ header, children }) => (
  <BorderedGrid sx={{ padding: 2.5, overflow: 'hidden' }}>
    {header}
    {children}
  </BorderedGrid>
);
